// extracted by mini-css-extract-plugin
module.exports = {"artistCard":"LazyUserList_artistCard__p58Er","loading":"LazyUserList_loading__F2oxZ"};